import { endpoints } from "@/configs/Settings";
import { auxiliarData } from "../AuxiliarData";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import { HTTPResponseStatus } from "@/utils/enum";
import { CoverageFormData } from "@/pages/patientinsurance/components/CoverageModal";

export async function PostCoverage(
  coverageFormData: CoverageFormData,
  references: { patientId: string }
) {
  const url = `${endpoints.ADMFHIR}/Coverage`;

  const data = auxiliarData.Coverage(coverageFormData, references);

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostCoverage: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostCoverage ", error);

      throw new Error();
    });
  if (response) return response;
}
